import { useEffect, useState } from "react";
import DataTable from "../../../components/table/data/DataTable";
import { Box, IconButton, Paper } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useNavigate } from "react-router-dom";
import { useTicketColumns } from "../../../hooks/useTableColumns";
import moment from "moment";
import ticketService from "../../../services/ticket/TicketService";
import { ITicketDisplay } from "../../../models/ticket/ticketDisplay";

interface ToolbarProps {
  onFilterClick: () => void;
}
const Toolbar = ({ onFilterClick }: ToolbarProps) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      component={Paper}
      sx={{ width: "100%", padding: 1, marginBottom: 1, paddingX: 2 }}
    >
      <IconButton onClick={onFilterClick}>
        <FilterAltIcon></FilterAltIcon>
      </IconButton>
    </Box>
  );
};

const TicketsPage = () => {
  const columns = useTicketColumns();
  const navigate = useNavigate();
  const [isFilterDisable, setIsFilterDisable] = useState<boolean>(false);
  const [tickets, setTickets] = useState<ITicketDisplay[]>([]);

  useEffect(() => {
    ticketService.GetTicketsByCompany().then((detailedTickets) => {
      if (!detailedTickets) return;

      let formattedTickets: ITicketDisplay[] = detailedTickets.map<ITicketDisplay>((ticket) =>
      ({
        id: ticket.ticket.id,
        date: ticket.ticket.date,
        buildingName: ticket.building.name,
        localName: ticket.local.name,
        floorName: ticket.floor.name,
        userName: ticket.user.name,
        number: ticket.ticket.number?.toString() || "☓",
        request: ticket.ticketHeader.request?.trim(),
        imageKeys: ticket.ticketHeader.imageKeys,
      }))

      setTickets(formattedTickets.sort((a, b) => moment(b.date).unix() - moment(a.date).unix()));
    })
  }, []);
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Toolbar
        onFilterClick={() => setIsFilterDisable((old) => !old)}
      />

      <DataTable
        dense
        disableFiltrer={isFilterDisable}
        rows={tickets}
        columns={columns}
        onRowClick={(row) =>
          navigate("details", { state: { ...row } })
        }
        getRowNavTo={(row) => "edit"}
      />
    </Box>
  );
};
export default TicketsPage;
